import styled from 'styled-components'
import { ModalFooter } from '@rodeo-dev/legos'

const DialogPdfPreviewFooter = styled(ModalFooter)`
  display: flex;
  justify-content: flex-end;
  padding: 20px;

  button {
    text-transform: uppercase;
  }
`

export default DialogPdfPreviewFooter
